import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../AppContext';
import { Actions } from '../../enums/ActionEnums';
import { IContact, useExcludeRecipientMutation, useRecipientsQuery } from '../../generated/graphql';
import DenseTable from '../Common/Tables/DenseTable';

const Recipients: React.FunctionComponent = () => {
  const { state, dispatch } = useContext(AppContext);
  const [recipients, setRecipients] = useState<IContact[]>([]);
  const [excludeRecipient] = useExcludeRecipientMutation();
  const constactsQuery = useRecipientsQuery({
    variables: { id: parseInt(state.selectedRecipientList?.id as string) },
    fetchPolicy: 'no-cache'
  });
  const [recipientsCount, setRecipientsCount] = useState(0);

  useEffect(() => {
    if (constactsQuery.data?.result) {
      setRecipients(constactsQuery.data.result as IContact[]);
      setRecipientsCount(constactsQuery.data.result.length);
    }
  }, [constactsQuery.data]);

  const columns = [
    {
      title: 'First Name',
      width: 350,
      field: 'first_name'
    },
    {
      title: 'Last Name',
      width: 350,
      field: 'last_name'
    },
    {
      title: 'Title',
      width: 268,
      field: 'titleInternal.name'
    },
    {
      title: 'Email',
      width: 293,
      field: 'email'
    },
    {
      title: 'Remove',
      sorting: false,
      width: 80
    }
  ];

  const handleRemove = (rowData: IContact) => {
    dispatch({
      type: Actions.ShowConfirmation,
      payload: {
        text: `Are you sure you want to exclude ${rowData.first_name} ${rowData.last_name} from ${state.selectedRecipientList?.name} recipient list?`,
        params: rowData,
        agreeAction: handleRemoveConfirmed
      }
    });
  };

  const handleRemoveConfirmed = (rowData: IContact) => {
    excludeRecipient({
      variables: {
        contact_id: parseInt(rowData.id),
        recipient_list_id: parseInt(state.selectedRecipientList?.id as string)
      },
      update() {
        setRecipients(recipients.filter((r) => r.id !== rowData.id));
        setRecipientsCount(recipientsCount - 1);
        dispatch({
          type: Actions.ShowMessage,
          payload: {
            text: `${rowData.first_name} ${rowData.last_name} removed from ${state.selectedRecipientList?.name} recipient list`,
            severity: 'success'
          }
        });
      }
    })
      .catch((e) => {
        dispatch({
          type: Actions.ShowMessage,
          payload: {
            severity: 'error',
            autoHide: 6000,
            text: e.message
          }
        });
      })
      .finally(() => {
        dispatch({
          type: Actions.HideConfirmation
        });
      });
  };

  return (
    <DenseTable
      columns={columns}
      data={recipients}
      loading={constactsQuery.loading}
      handleDetails={() => true}
      handleRemove={handleRemove}
      pageSize={15}
      removeButtonStyle={'minus'}
      title={`${recipientsCount} Recipients`}
    />
  );
};

export default Recipients;
